import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={830}
    height={117}
    viewBox="0 0 830 117"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M829 105.122C811.604 98.7416 786.298 92.0702 755.5 91.3014C734 90.7646 683.5 94.79 638.5 93.0457C593.5 91.3014 563.5 70.2355 530.5 63.6608C497.5 57.0861 498.5 71.9798 455 69.833C411.5 67.6861 424.5 55.0735 392 48.9013C359.5 42.7292 319 40.4481 285.5 37.0937C252 33.7393 234 15.4912 188.5 9.31899C143 3.14683 1 0.999996 1 0.999996"
      stroke="url(#paint0_linear_16_34)"
    />
    <path
      d="M829 116C811.604 108.953 786.298 101.585 755.5 100.736C734 100.143 683.5 104.589 638.5 102.662C593.5 100.736 563.5 77.4691 530.5 70.2075C497.5 62.9459 498.5 79.3956 455 77.0245C411.5 74.6534 424.5 60.7229 392 53.9059C359.5 47.0889 319 44.5696 285.5 40.8647C252 37.1598 234 17.0052 188.5 10.1881C143 3.37114 1 1 1 1"
      stroke="url(#paint1_linear_16_34)"
    />
    <path
      d="M285.5 35.7469C252 32.5177 234 14.9504 188.5 9.00858C143 3.06673 1.00024 1 1.00024 1H829V101.236C811.604 95.0946 786.298 88.672 755.5 87.9319C734 87.4152 683.5 91.2903 638.5 89.6111C593.5 87.9319 563.5 67.6521 530.5 61.3227C497.5 54.9934 498.5 69.3313 455 67.2646C411.5 65.1979 424.5 53.0558 392 47.114C359.5 41.1721 319 38.9762 285.5 35.7469Z"
      fill="url(#paint2_linear_16_34)"
    />
    <path
      d="M785.583 88.3121C810.535 90.3726 829 87.3795 829 87.3795V1L303 1.77267C303 1.77267 400.814 41.179 447.226 45.1712C493.638 49.1633 490.643 40.6639 522.583 43.4971C554.522 46.3302 571.49 63.5866 609.417 66.5485C647.345 69.5104 647.345 62.4276 682.279 66.5485C717.213 70.6694 760.63 86.2517 785.583 88.3121Z"
      fill="url(#paint3_linear_16_34)"
    />
    <path
      d="M829 93.5053C829 93.5053 810.535 96.7107 785.583 94.5041C760.63 92.2975 717.213 75.6102 682.279 71.197C647.345 66.7838 647.345 74.369 609.417 71.197C571.49 68.0251 554.522 49.5449 522.583 46.5108C490.643 43.4768 493.638 52.5789 447.226 48.3037C400.814 44.0284 303 1.82748 303 1.82748"
      stroke="url(#paint4_linear_16_34)"
    />
    <path
      d="M829 89.693C829 89.693 810.535 92.7668 785.583 90.6508C760.63 88.5347 717.213 72.5322 682.279 68.3001C647.345 64.068 647.345 71.3419 609.417 68.3001C571.49 65.2583 554.522 47.5364 522.583 44.6268C490.643 41.7173 493.638 50.446 447.226 46.3461C400.814 42.2463 303 1.77703 303 1.77703"
      stroke="url(#paint5_linear_16_34)"
    />
    <path
      d="M273 31.1398C247 26.6318 215 11.5618 178 8.34174C141 5.12168 1.00024 1 1.00024 1H827L829 41.1464C829 41.1464 696 20.7068 635.5 23.2828C575 25.8589 560 77.8951 501 76.6071C442 75.3191 440.5 52.1346 395.5 42.8608C350.5 33.5871 299 35.6479 273 31.1398Z"
      fill="url(#paint6_linear_16_34)"
    />
    <path
      d="M829 42.2463C829 42.2463 696 21.2467 635.5 23.8933C575 26.54 560 80.0018 501 78.6785C442 77.3552 440.5 53.5355 395.5 44.0077C350.5 34.4799 299 36.5971 273 31.9656C247 27.334 215 11.8512 178 8.54288C141 5.2346 1 0.999997 1 0.999997"
      stroke="url(#paint7_linear_16_34)"
    />
    <ellipse
      cx={1.11383}
      cy={0.865885}
      rx={1.11383}
      ry={0.865885}
      transform="matrix(1 0 0 -1 163.663 40.5474)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.93}
      cx={0.767963}
      cy={0.754962}
      rx={0.767963}
      ry={0.754962}
      transform="matrix(-0.794782 -0.606895 -0.727948 0.685632 172.986 43.0188)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.86}
      cx={0.783784}
      cy={0.824392}
      rx={0.783784}
      ry={0.824392}
      transform="matrix(-0.650601 0.75942 0.851366 0.524572 214.822 52.8185)"
      fill="#40DCFF"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.7}
      cx={0.980821}
      cy={1.0992}
      rx={0.980821}
      ry={1.0992}
      transform="matrix(0.447587 -0.89424 -0.940893 -0.338704 247.059 42.868)"
      fill="#40DCFF"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.79}
      cx={0.633129}
      cy={0.550745}
      rx={0.633129}
      ry={0.550745}
      transform="matrix(0.971682 0.236292 0.320304 -0.947315 156.986 23.1681)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.81}
      cx={1.14328}
      cy={1.1113}
      rx={1.14328}
      ry={1.1113}
      transform="matrix(-0.814763 -0.579794 -0.70334 0.710854 183.178 29.1987)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <ellipse
      cx={1.27386}
      cy={1.48698}
      rx={1.27386}
      ry={1.48698}
      transform="matrix(-0.203564 -0.979062 -0.989004 0.147892 252.392 30.254)"
      fill="#40DCFF"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.93}
      cx={1.62021}
      cy={1.37628}
      rx={1.62021}
      ry={1.37628}
      transform="matrix(-0.998246 -0.0591983 -0.0821758 0.996618 131.208 10.1017)"
      fill="#40DCFF"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.89}
      cx={1.44358}
      cy={1.61099}
      rx={1.44358}
      ry={1.61099}
      transform="matrix(-0.46483 -0.8854 -0.935533 0.35324 194.2 14.1724)"
      fill="#40DCFF"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.72}
      cx={1.39323}
      cy={1.18263}
      rx={1.39323}
      ry={1.18263}
      transform="matrix(-0.999014 -0.0444013 -0.0616794 0.998096 257.548 12.514)"
      fill="#40DCFF"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.89}
      cx={0.697115}
      cy={0.777959}
      rx={0.697115}
      ry={0.777959}
      transform="matrix(-0.46483 -0.8854 -0.935533 0.35324 116.408 11.4172)"
      fill="#40DCFF"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.85}
      cx={0.51728}
      cy={0.500003}
      rx={0.51728}
      ry={0.500003}
      transform="matrix(-0.824331 -0.566108 -0.690596 0.723241 130.335 44.7167)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <ellipse
      cx={0.379143}
      cy={0.407777}
      rx={0.379143}
      ry={0.407777}
      transform="matrix(-0.143288 -0.989681 -0.994622 0.103569 133.451 35.2551)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.99}
      cx={0.392545}
      cy={0.461694}
      rx={0.392545}
      ry={0.461694}
      transform="matrix(-0.102618 -0.994721 -0.997259 0.0739925 146.962 52.8913)"
      fill="#1C41C2"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.79}
      cx={0.472583}
      cy={0.438165}
      rx={0.472583}
      ry={0.438165}
      transform="matrix(0.739813 0.672813 0.784364 -0.6203 140.09 54.238)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.76}
      cx={0.307303}
      cy={0.308711}
      rx={0.307303}
      ry={0.308711}
      transform="matrix(0.531198 -0.847248 -0.911606 -0.411064 158.618 51.5215)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.94}
      cx={0.376152}
      cy={0.374014}
      rx={0.376152}
      ry={0.374014}
      transform="matrix(0.77366 -0.633601 -0.751386 -0.659863 218.599 54.5575)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <ellipse
      cx={0.515568}
      cy={0.437636}
      rx={0.515568}
      ry={0.437636}
      transform="matrix(0.999014 0.0444013 0.0616794 -0.998096 112.769 47.255)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.99}
      cx={0.411857}
      cy={0.364926}
      rx={0.411857}
      ry={0.364926}
      transform="matrix(-0.824331 -0.566108 -0.690596 0.723241 161.256 49.4921)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.77}
      cx={0.554217}
      cy={0.582932}
      rx={0.554217}
      ry={0.582932}
      transform="matrix(0.650601 -0.75942 -0.851366 -0.524572 232.165 46.6158)"
      fill="#40DCFF"
      fillOpacity={0.7}
    />
    <ellipse
      cx={0.40215}
      cy={0.469431}
      rx={0.40215}
      ry={0.469431}
      transform="matrix(-0.203564 0.979062 0.989004 0.147892 142.351 41.8699)"
      fill="#1C41C2"
      fillOpacity={0.7}
    />
    <ellipse
      cx={0.294878}
      cy={0.321606}
      rx={0.294878}
      ry={0.321606}
      transform="matrix(-0.547115 -0.837057 -0.904993 0.425427 193.853 41.7101)"
      fill="white"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.73}
      cx={0.499552}
      cy={0.455833}
      rx={0.499552}
      ry={0.455833}
      transform="matrix(0.911606 0.411064 0.531198 -0.847248 247.051 42.6689)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.87}
      cx={0.298248}
      cy={0.301665}
      rx={0.298248}
      ry={0.301665}
      transform="matrix(0.739813 -0.672813 -0.784364 -0.6203 106.928 38.5622)"
      fill="#1C41C2"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.86}
      cx={0.374609}
      cy={0.398275}
      rx={0.374609}
      ry={0.398275}
      transform="matrix(-0.622474 0.78264 0.86802 0.49653 173.503 39.521)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.82}
      cx={0.326184}
      cy={0.313541}
      rx={0.326184}
      ry={0.313541}
      transform="matrix(-0.833619 0.552339 0.677558 0.73547 251.384 39.8406)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.88}
      cx={0.344024}
      cy={0.371854}
      rx={0.344024}
      ry={0.371854}
      transform="matrix(0 -1 -1 0 118.798 32.2184)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.87}
      cx={0.417493}
      cy={0.481384}
      rx={0.417493}
      ry={0.481384}
      transform="matrix(0.301274 0.953538 0.97514 -0.221589 181.794 31.2596)"
      fill="#40DCFF"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.71}
      cx={0.597853}
      cy={0.518504}
      rx={0.597853}
      ry={0.518504}
      transform="matrix(-0.97514 -0.221589 -0.301274 0.953538 218.034 30.7803)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.72}
      cx={0.49908}
      cy={0.388337}
      rx={0.49908}
      ry={0.388337}
      transform="matrix(0.999014 0.0444013 0.0616794 -0.998096 118.421 26.5138)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.81}
      cx={0.394958}
      cy={0.367624}
      rx={0.394958}
      ry={0.367624}
      transform="matrix(0.883599 -0.468244 -0.593187 -0.805065 196.114 25.2354)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.96}
      cx={0.501376}
      cy={0.457497}
      rx={0.501376}
      ry={0.457497}
      transform="matrix(-0.911606 0.411064 0.531198 0.847248 254.776 26.354)"
      fill="#1C41C2"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.75}
      cx={0.365888}
      cy={0.33548}
      rx={0.365888}
      ry={0.33548}
      transform="matrix(0.904993 -0.425427 -0.547115 -0.837057 155.164 21.6081)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.79}
      cx={0.391781}
      cy={0.431385}
      rx={0.391781}
      ry={0.431385}
      transform="matrix(-0.515007 0.857186 0.917965 0.396662 158.618 23.206)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.94}
      cx={0.389418}
      cy={0.330555}
      rx={0.389418}
      ry={0.330555}
      transform="matrix(-0.999014 0.0444013 0.0616794 0.998096 230.469 21.2885)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.94}
      cx={0.346782}
      cy={0.408244}
      rx={0.346782}
      ry={0.408244}
      transform="matrix(-0.0821758 0.996618 0.998246 0.0591983 122.943 19.2591)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.94}
      cx={0.496537}
      cy={0.507954}
      rx={0.496537}
      ry={0.507954}
      transform="matrix(0.715791 0.698315 0.804914 -0.593391 186.881 17.3416)"
      fill="#40DCFF"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.91}
      cx={0.265238}
      cy={0.233891}
      rx={0.265238}
      ry={0.233891}
      transform="matrix(0.955516 -0.294939 -0.39439 -0.918943 217.28 14.7849)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.91}
      cx={0.328032}
      cy={0.382113}
      rx={0.328032}
      ry={0.382113}
      transform="matrix(0.223412 -0.974724 -0.986684 -0.162652 107.304 13.3947)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.82}
      cx={0.454003}
      cy={0.51088}
      rx={0.454003}
      ry={0.51088}
      transform="matrix(0.430095 -0.902783 -0.946009 -0.32414 172.373 14.1937)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.95}
      cx={0.325913}
      cy={0.316797}
      rx={0.325913}
      ry={0.316797}
      transform="matrix(0.814763 -0.579794 -0.70334 -0.710854 258.921 9.87927)"
      fill="#1C41C2"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.74}
      cx={0.471335}
      cy={0.553017}
      rx={0.471335}
      ry={0.553017}
      transform="matrix(-0.143288 -0.989681 -0.994622 0.103569 104.855 9.44782)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.88}
      cx={0.471009}
      cy={0.385261}
      rx={0.471009}
      ry={0.385261}
      transform="matrix(0.940893 -0.338704 -0.447587 -0.89424 183.867 7.69009)"
      fill="#C2F8FF"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.9}
      cx={0.749949}
      cy={0.601896}
      rx={0.749949}
      ry={0.601896}
      transform="matrix(-0.964069 -0.265652 -0.357772 0.933809 226.018 92.0831)"
      fill="#111F87"
    />
    <ellipse
      opacity={0.94}
      cx={0.762509}
      cy={0.669945}
      rx={0.762509}
      ry={0.669945}
      transform="matrix(-0.959911 0.280305 0.376191 0.926542 229.244 91.0624)"
      fill="#111F87"
    />
    <ellipse
      opacity={0.85}
      cx={0.734895}
      cy={0.635561}
      rx={0.734895}
      ry={0.635561}
      transform="matrix(0.978368 -0.206872 -0.28206 -0.959397 241.652 86.885)"
      fill="#111F87"
    />
    <ellipse
      opacity={0.85}
      cx={1.07118}
      cy={1.0354}
      rx={1.07118}
      ry={1.0354}
      transform="matrix(-0.824331 -0.566108 -0.690596 0.723241 223.04 83.1285)"
      fill="#111F87"
    />
    <ellipse
      opacity={0.87}
      cx={0.740492}
      cy={0.674927}
      rx={0.740492}
      ry={0.674927}
      transform="matrix(0.77366 -0.633601 -0.751386 -0.659863 215.496 78.7406)"
      fill="#111F87"
    />
    <ellipse
      opacity={0.89}
      cx={0.661939}
      cy={0.561424}
      rx={0.661939}
      ry={0.561424}
      transform="matrix(-0.99989 -0.0148014 -0.0205779 0.999788 236.937 80.4242)"
      fill="#111F87"
    />
    <ellipse
      opacity={0.92}
      cx={0.596789}
      cy={0.634233}
      rx={0.596789}
      ry={0.634233}
      transform="matrix(0.262671 -0.964886 -0.981367 -0.192143 239.666 75.405)"
      fill="#111F87"
    />
    <ellipse
      opacity={0.86}
      cx={0.718779}
      cy={0.601218}
      rx={0.718779}
      ry={0.601218}
      transform="matrix(0.911606 0.411064 0.531198 -0.847248 213.263 68.5232)"
      fill="#111F87"
    />
    <ellipse
      opacity={0.83}
      cx={0.630243}
      cy={0.65202}
      rx={0.630243}
      ry={0.65202}
      transform="matrix(0.690596 -0.723241 -0.824331 -0.566108 243.141 65.3981)"
      fill="#111F87"
    />
    <ellipse
      opacity={0.71}
      cx={0.547814}
      cy={0.52818}
      rx={0.547814}
      ry={0.52818}
      transform="matrix(0.650601 0.75942 0.851366 -0.524572 214.255 63.3251)"
      fill="#111F87"
    />
    <ellipse
      cx={0.785123}
      cy={0.844419}
      rx={0.785123}
      ry={0.844419}
      transform="matrix(-0.143288 -0.989681 -0.994622 0.103569 229.492 63.5356)"
      fill="#111F87"
    />
    <ellipse
      opacity={0.92}
      cx={0.668316}
      cy={0.757887}
      rx={0.668316}
      ry={0.757887}
      transform="matrix(-0.39439 0.918943 0.955516 0.294939 243.637 60.6209)"
      fill="#111F87"
    />
    <ellipse
      opacity={0.97}
      cx={0.90244}
      cy={0.819592}
      rx={0.90244}
      ry={0.819592}
      transform="matrix(-0.917965 -0.396662 -0.515007 0.857186 273.268 102.94)"
      fill="#1C41C2"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.99}
      cx={0.812876}
      cy={0.956069}
      rx={0.812876}
      ry={0.956069}
      transform="matrix(-0.102618 -0.994721 -0.997259 0.0739925 257.471 100.056)"
      fill="#1C41C2"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.74}
      cx={0.423609}
      cy={0.421201}
      rx={0.423609}
      ry={0.421201}
      transform="matrix(0.77366 -0.633601 -0.751386 -0.659863 247.626 97.7556)"
      fill="#1C41C2"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.91}
      cx={0.615049}
      cy={0.599412}
      rx={0.615049}
      ry={0.599412}
      transform="matrix(-0.622474 -0.78264 -0.86802 0.49653 268.689 95.649)"
      fill="#1C41C2"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.82}
      cx={0.619689}
      cy={0.529863}
      rx={0.619689}
      ry={0.529863}
      transform="matrix(0.991099 -0.133124 -0.183586 -0.983004 298.772 95.2607)"
      fill="#1C41C2"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.76}
      cx={0.534517}
      cy={0.455567}
      rx={0.534517}
      ry={0.455567}
      transform="matrix(-0.994622 0.103569 0.143288 0.989681 249.458 93.3482)"
      fill="#1C41C2"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.93}
      cx={0.39361}
      cy={0.334658}
      rx={0.39361}
      ry={0.334658}
      transform="matrix(-0.997259 0.0739925 0.102618 0.994721 268.689 88.9118)"
      fill="#1C41C2"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.75}
      cx={0.701117}
      cy={0.596109}
      rx={0.701117}
      ry={0.596109}
      transform="matrix(-0.997259 -0.0739925 -0.102618 0.994721 239.522 85.6403)"
      fill="#1C41C2"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.8}
      cx={0.785086}
      cy={0.727908}
      rx={0.785086}
      ry={0.727908}
      transform="matrix(-0.739813 0.672813 0.784364 0.6203 265.942 86.611)"
      fill="#1C41C2"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.88}
      cx={0.769451}
      cy={0.769262}
      rx={0.769451}
      ry={0.769262}
      transform="matrix(0.547115 0.837057 0.904993 -0.425427 290.301 87.3876)"
      fill="#1C41C2"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.74}
      cx={0.65635}
      cy={0.690355}
      rx={0.65635}
      ry={0.690355}
      transform="matrix(0.650601 0.75942 0.851366 -0.524572 275.099 84.3103)"
      fill="#1C41C2"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.75}
      cx={0.710691}
      cy={0.639615}
      rx={0.710691}
      ry={0.639615}
      transform="matrix(-0.929926 0.367747 0.481818 0.876271 269.376 80.8446)"
      fill="#1C41C2"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.97}
      cx={0.785435}
      cy={0.836773}
      rx={0.785435}
      ry={0.836773}
      transform="matrix(0.243118 0.969997 0.984138 -0.177402 245.566 75.2432)"
      fill="#1C41C2"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.86}
      cx={0.958235}
      cy={1.03476}
      rx={0.958235}
      ry={1.03476}
      transform="matrix(0.578113 -0.815957 -0.890991 -0.45402 272.966 66.5293)"
      fill="#1C41C2"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.73}
      cx={0.900773}
      cy={0.70204}
      rx={0.900773}
      ry={0.70204}
      transform="matrix(0.997259 0.0739925 0.102618 -0.994721 295.109 74.1074)"
      fill="#1C41C2"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.82}
      cx={0.498027}
      cy={0.572525}
      rx={0.498027}
      ry={0.572525}
      transform="matrix(-0.320304 -0.947315 -0.971682 0.236292 270.063 69.0885)"
      fill="#1C41C2"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.89}
      cx={0.920941}
      cy={1.03632}
      rx={0.920941}
      ry={1.03632}
      transform="matrix(0.430095 -0.902783 -0.946009 -0.32414 288.469 71.0301)"
      fill="#1C41C2"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.91}
      cx={0.361312}
      cy={0.423927}
      rx={0.361312}
      ry={0.423927}
      transform="matrix(0.143288 -0.989681 -0.994622 -0.103569 256.253 62.5103)"
      fill="#1C41C2"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.79}
      cx={0.505528}
      cy={0.439747}
      rx={0.505528}
      ry={0.439747}
      transform="matrix(-0.971682 -0.236292 -0.320304 0.947315 298.314 66.3995)"
      fill="#1C41C2"
      fillOpacity={0.7}
    />
    <ellipse
      opacity={0.74}
      cx={0.613307}
      cy={0.630955}
      rx={0.613307}
      ry={0.630955}
      transform="matrix(-0.70334 0.710854 0.814763 0.579794 252.434 64.487)"
      fill="#1C41C2"
      fillOpacity={0.7}
    />
    <path
      d="M76.1361 25.317C23.0399 26.0168 1 16.22 1 16.22V1H829V44.0358C752.326 44.0358 683.976 7.18018 609.603 4.49888C531.962 1.6998 509.841 47.3193 457.828 46.3101C430.779 45.7852 412.746 29.1657 388.202 28.8158C363.657 28.466 337.109 34.7639 294.532 34.0641C251.955 33.3644 220.397 17.4446 185.835 16.22C151.272 14.9954 129.232 24.6172 76.1361 25.317Z"
      fill="url(#paint8_linear_16_34)"
    />
    <path
      d="M76.1364 18.9251C23.0402 19.4409 1.00024 12.2193 1.00024 12.2193V1H829V32.7235C752.327 32.7235 683.977 5.55568 609.603 3.57917C531.962 1.51585 509.841 35.1439 457.828 34.4C430.779 34.0131 412.746 21.7622 388.202 21.5042C363.657 21.2463 337.109 25.8888 294.532 25.373C251.955 24.8572 220.398 13.122 185.835 12.2193C151.272 11.3166 129.233 18.4093 76.1364 18.9251Z"
      fill="url(#paint9_linear_16_34)"
    />
    <path
      d="M1 18.6552C1 18.6552 23.0399 30.0195 76.1361 29.2077C129.232 28.396 151.272 17.2347 185.835 18.6552C220.397 20.0757 251.955 38.5426 294.532 39.3544C337.109 40.1661 363.657 32.8605 388.202 33.2664C412.746 33.6722 430.779 52.9509 457.828 53.5597C509.841 54.7304 531.962 1.81177 609.603 5.0587C683.976 8.16901 752.326 50.9215 829 50.9215"
      stroke="url(#paint10_linear_16_34)"
    />
    <path
      d="M1 13.411C1 13.411 23.0399 17.4635 76.1361 17.1741C129.232 16.8846 151.272 12.9044 185.835 13.411C220.397 13.9176 251.955 20.5029 294.532 20.7924C337.109 21.0818 363.657 18.4767 388.201 18.6214C412.746 18.7661 430.779 25.6409 457.828 25.858C509.841 26.2755 531.962 7.4046 609.603 8.56246C683.976 9.6716 752.326 24.9173 829 24.9173"
      stroke="url(#paint11_linear_16_34)"
    />
    <path
      d="M726.992 42.9595C764.492 51.5068 828.992 54.8739 828.992 54.8739V1H588.492C588.492 1 618.492 6.6982 635.992 11.7489C653.492 16.7996 689.492 34.4122 726.992 42.9595Z"
      fill="url(#paint12_linear_16_34)"
    />
    <ellipse
      cx={0.786597}
      cy={0.787784}
      rx={0.786597}
      ry={0.787784}
      transform="matrix(1 0 0 -1 750.364 32.5153)"
      fill="white"
      fillOpacity={0.92}
    />
    <ellipse
      opacity={0.93}
      cx={0.60465}
      cy={0.610256}
      rx={0.60465}
      ry={0.610256}
      transform="matrix(-0.712878 -0.701288 -0.635982 0.771704 756.948 34.7638)"
      fill="white"
      fillOpacity={0.92}
    />
    <ellipse
      opacity={0.86}
      cx={0.65034}
      cy={0.632833}
      rx={0.65034}
      ry={0.632833}
      transform="matrix(-0.553735 0.832693 0.783237 0.621724 786.493 43.6796)"
      fill="#5DE1FF"
    />
    <ellipse
      opacity={0.7}
      cx={0.856087}
      cy={0.805099}
      rx={0.856087}
      ry={0.805099}
      transform="matrix(0.362144 -0.932122 -0.90719 -0.420721 809.259 34.6266)"
      fill="#5DE1FF"
    />
    <ellipse
      opacity={0.79}
      cx={0.45528}
      cy={0.490746}
      rx={0.45528}
      ry={0.490746}
      transform="matrix(0.954266 0.298958 0.253856 -0.967242 745.648 16.7035)"
      fill="white"
      fillOpacity={0.92}
    />
    <ellipse
      opacity={0.81}
      cx={0.892435}
      cy={0.906224}
      rx={0.892435}
      ry={0.906224}
      transform="matrix(-0.737119 -0.675763 -0.609105 0.793089 764.146 22.1902)"
      fill="white"
      fillOpacity={0.92}
    />
    <ellipse
      cx={1.14938}
      cy={1.05766}
      rx={1.14938}
      ry={1.05766}
      transform="matrix(-0.159328 -0.987226 -0.981945 0.189169 813.025 23.1504)"
      fill="#5DE1FF"
    />
    <ellipse
      opacity={0.93}
      cx={1.14552}
      cy={1.25046}
      rx={1.14552}
      ry={1.25046}
      transform="matrix(-0.997094 -0.0761769 -0.0638723 0.997958 727.444 4.81578)"
      fill="#5DE1FF"
    />
    <ellipse
      opacity={0.89}
      cx={1.2557}
      cy={1.18359}
      rx={1.2557}
      ry={1.18359}
      transform="matrix(-0.377379 -0.926059 -0.899253 0.43743 771.929 8.51927)"
      fill="#5DE1FF"
    />
    <ellipse
      opacity={0.72}
      cx={0.984545}
      cy={1.07515}
      rx={0.984545}
      ry={1.07515}
      transform="matrix(-0.998365 -0.0571648 -0.047913 0.998851 816.666 7.01044)"
      fill="#5DE1FF"
    />
    <defs>
      <linearGradient
        id="paint0_linear_16_34"
        x1={785.5}
        y1={97.4809}
        x2={556.151}
        y2={-289.359}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5344FF" stopOpacity={0.66} />
        <stop offset={0.465838} stopColor="#65DAF8" />
        <stop offset={1} stopColor="#0F00B8" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="paint1_linear_16_34"
        x1={785.5}
        y1={107.561}
        x2={520.857}
        y2={-296.584}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1D10AC" stopOpacity={0.66} />
        <stop offset={1} stopColor="#0F00B8" stopOpacity={0.76} />
      </linearGradient>
      <linearGradient
        id="paint2_linear_16_34"
        x1={446}
        y1={80.2568}
        x2={500.539}
        y2={-75.1091}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8FA9FF" />
        <stop offset={0.515} stopColor="#2256FF" />
        <stop offset={1} stopColor="#002AB3" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_16_34"
        x1={430.258}
        y1={55.4735}
        x2={596.031}
        y2={-136.801}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0911019} stopColor="#275AFF" />
        <stop offset={1} stopColor="#1C1D5C" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_16_34"
        x1={566}
        y1={95.2793}
        x2={566}
        y2={1.82748}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4256F0" />
        <stop offset={1} stopColor="#0B008A" stopOpacity={0.58} />
      </linearGradient>
      <linearGradient
        id="paint5_linear_16_34"
        x1={566}
        y1={91.3941}
        x2={566}
        y2={1.77703}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5A6CFF" />
        <stop offset={1} stopColor="white" stopOpacity={0.29} />
      </linearGradient>
      <linearGradient
        id="paint6_linear_16_34"
        x1={414}
        y1={76.5481}
        x2={414}
        y2={0.99999}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9EEBF7" />
        <stop offset={0.46} stopColor="#2AE5FF" stopOpacity={0.74} />
        <stop offset={1} stopColor="#4BA4DE" stopOpacity={0.46} />
      </linearGradient>
      <linearGradient
        id="paint7_linear_16_34"
        x1={415}
        y1={78.7027}
        x2={415}
        y2={0.999996}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#59D5F7" stopOpacity={0.34} />
        <stop offset={1} stopColor="#59D5F7" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="paint8_linear_16_34"
        x1={205.871}
        y1={33.3644}
        x2={568.995}
        y2={-132.212}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3C29CC" stopOpacity={0.05} />
        <stop offset={1} stopColor="#002A98" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_16_34"
        x1={205.871}
        y1={24.8572}
        x2={557.533}
        y2={-209.345}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3C29CC" stopOpacity={0.68} />
        <stop offset={0.29} stopColor="#192AAE" stopOpacity={0.8656} />
        <stop offset={0.755} stopColor="#001856" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_16_34"
        x1={537.5}
        y1={57.982}
        x2={526.953}
        y2={-15.146}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#344FDB" />
        <stop offset={1} stopColor="#6865F8" stopOpacity={0.23} />
      </linearGradient>
      <linearGradient
        id="paint11_linear_16_34"
        x1={537.5}
        y1={27.435}
        x2={536.135}
        y2={0.88522}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4664FF" />
        <stop offset={1} stopColor="#6865F8" stopOpacity={0.23} />
      </linearGradient>
      <linearGradient
        id="paint12_linear_16_34"
        x1={709.742}
        y1={54.8739}
        x2={709.742}
        y2={1.00001}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2F2F8F" stopOpacity={0.6} />
        <stop offset={1} stopColor="#131368" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgComponent;
